/** Mirrors server notificationCatalog.js */
export const NOTIFICATION_EVENTS = [
  { id: 'credentials', label: 'Portal credentials (welcome)', group: 'Accounts' },
  { id: 'welcome', label: 'Candidate registration welcome', group: 'Accounts' },
  { id: 'candidate_registered_admin', label: 'New candidate registration → admin', group: 'Accounts' },
  { id: 'candidate_registered_recruiter', label: 'New candidate registration → recruiter', group: 'Accounts' },
  { id: 'profile_completion', label: 'Profile completion reminder → candidate', group: 'Accounts' },
  { id: 'password_reset', label: 'Password reset link', group: 'Accounts' },
  { id: 'password_changed', label: 'Password changed confirmation', group: 'Accounts' },

  { id: 'job_created_client', label: 'New job posted → client', group: 'Jobs → Client' },
  { id: 'job_created_recruiter', label: 'New job posted → recruiter', group: 'Jobs → Recruiter' },
  { id: 'job_created_admin', label: 'New job posted → admin', group: 'Jobs → Admin' },
  { id: 'job_recommended_candidate', label: 'Recommended job match → candidate', group: 'Jobs → Candidate' },
  { id: 'candidate_referral_recruiter', label: 'Candidate referral submitted → recruiter', group: 'Referrals' },
  { id: 'candidate_referral_admin', label: 'Candidate referral submitted → admin', group: 'Referrals' },

  { id: 'job_status_client', label: 'Job status change → client', group: 'Jobs → Client' },
  { id: 'job_status_recruiter', label: 'Job status change → recruiter', group: 'Jobs → Recruiter' },
  { id: 'job_status_admin', label: 'Job status change → admin', group: 'Jobs → Admin' },

  { id: 'recruiter_assigned_client', label: 'Recruiter assigned → client', group: 'Jobs → Client' },
  { id: 'recruiter_assigned_recruiter', label: 'Recruiter assigned → recruiter', group: 'Jobs → Recruiter' },

  { id: 'application_submitted_candidate', label: 'Application submitted → candidate', group: 'ATS → Candidate' },
  { id: 'application_submitted_client', label: 'Application submitted → client', group: 'ATS → Client' },
  { id: 'application_submitted_recruiter', label: 'Application submitted → recruiter', group: 'ATS → Recruiter' },

  { id: 'application_stage_candidate', label: 'Stage update → candidate', group: 'ATS → Candidate' },
  { id: 'application_stage_client', label: 'Stage update → client', group: 'ATS → Client' },
  { id: 'application_stage_recruiter', label: 'Stage update → recruiter', group: 'ATS → Recruiter' },
  { id: 'application_stage_admin', label: 'Stage update (joined) → admin', group: 'ATS → Admin' },

  { id: 'interview_activity_candidate', label: 'Interview update → candidate', group: 'ATS → Candidate' },
  { id: 'interview_activity_client', label: 'Interview update → client', group: 'ATS → Client' },
  { id: 'interview_activity_recruiter', label: 'Interview update → recruiter', group: 'ATS → Recruiter' },

  { id: 'offer_activity_candidate', label: 'Offer update → candidate', group: 'ATS → Candidate' },
  { id: 'offer_activity_client', label: 'Offer update → client', group: 'ATS → Client' },
  { id: 'offer_activity_recruiter', label: 'Offer update → recruiter', group: 'ATS → Recruiter' },

  { id: 'offer_document_candidate', label: 'Document uploaded → candidate', group: 'ATS → Candidate' },
  { id: 'offer_document_client', label: 'Document uploaded → client', group: 'ATS → Client' },
  { id: 'offer_document_recruiter', label: 'Document uploaded → recruiter', group: 'ATS → Recruiter' }
];
